import { KEY_TOKEN_API } from "Shared/Constant/Cache";
import * as LocalVariableUtil from 'Shared/Utils/LocalVariable/index';
const setTokenAPI = (token?: string) => {
  let _token = LocalVariableUtil.set(KEY_TOKEN_API, token || '');
  return _token;
};

export default setTokenAPI;